// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3c584596","239":"c1e55d2c","453":"04041dc3","455":"a0b83758","457":"ce27f5ef"}[chunkId] + ".chunk.js";
};